import { Box, ChakraProvider, CSSReset } from '@chakra-ui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import Footer from './components/Footer'
import Navigation from './components/Navigation'
import Blog from './pages/Blog'
import DreamBook from './pages/DreamBook'
import DreamInterpretation from './pages/DreamInterpretation'
import Home from './pages/Home'
import BlogPost from './components/BlogPost'
import Vop from './pages/Vop'
import { useEffect } from 'react'
import PrecoSaNamSniva from './pages/blog/PrecoSaNamSniva'
import AkoZlepsitSpanok from './pages/blog/AkoZlepsitSpanok'
import LucidneSnivanie from './pages/blog/LucidneSnivanie'

const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation()

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

const queryClient = new QueryClient()
function App() {
  return (
    <ChakraProvider>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <CSSReset />
          <ErrorBoundary>
            <Router basename="/">
              <ScrollToTop />
              <Box minHeight="100vh" display="flex" flexDirection="column">
                <Navigation />
                <Box flex="1">
                  <Routes>
                    <Route path="/" Component={Home} />
                    <Route path="/vyklad" Component={DreamInterpretation} />
                    <Route path="/snar" Component={DreamBook} />
                    <Route path="/blog" Component={Blog} />
                    <Route path="/blog/1" Component={PrecoSaNamSniva} />
                    <Route path="/blog/2" Component={AkoZlepsitSpanok} />
                    <Route path="/blog/3" Component={LucidneSnivanie} />
                    <Route path="/vop" Component={Vop} />
                  </Routes>
                </Box>
                <Footer />
              </Box>
            </Router>
          </ErrorBoundary>
        </HelmetProvider>
      </QueryClientProvider>
    </ChakraProvider>
  )
}

export default App
